module.exports = __webpack_public_path__ + "img/n5.c312429a.png";